import React, { useState } from 'react';
import { KPISection } from '../components/KPISection';
import { EventStream } from '../components/EventStream';
import { TruckTracker } from '../components/TruckTracker';
import { BayAnalytics } from '../components/BayAnalytics';
import { GuardRoster } from '../components/GuardRoster';
import { AIAssistant } from '../components/AIAssistant';
import { Drawer } from '../components/ui/Drawer';
import { VehicleDrawer } from '../components/VehicleDrawer';
import { Vehicle } from '../utils/mockData';
export function Dashboard() {
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
  return <div className="min-h-screen bg-[#0f1115] text-gray-100 font-sans selection:bg-amber-500/30" data-id="element-462">
      {/* Header removed from here as it's now in App.tsx */}

      <main className="p-6 space-y-6 max-w-[1920px] mx-auto" data-id="element-463">
        {/* Section 1: KPIs */}
        <section data-id="element-464">
          <KPISection data-id="element-465" />
        </section>

        {/* Main Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 h-[calc(100vh-280px)] min-h-[800px]" data-id="element-466">
          {/* Left Column: Event Stream (3 cols) */}
          <div className="lg:col-span-3 h-full" data-id="element-467">
            <EventStream onVehicleClick={setSelectedVehicle} data-id="element-468" />
          </div>

          {/* Middle Column: Truck Tracker & Bay Analytics (6 cols) */}
          <div className="lg:col-span-6 flex flex-col gap-6 h-full" data-id="element-469">
            <div className="flex-[2] min-h-0" data-id="element-470">
              <TruckTracker onVehicleClick={setSelectedVehicle} data-id="element-471" />
            </div>
            <div className="flex-1 min-h-0" data-id="element-472">
              <BayAnalytics data-id="element-473" />
            </div>
          </div>

          {/* Right Column: Guards & AI Assistant (3 cols) */}
          <div className="lg:col-span-3 flex flex-col gap-6 h-full" data-id="element-474">
            <div className="flex-1 min-h-0" data-id="element-475">
              <GuardRoster data-id="element-476" />
            </div>
            <div className="flex-[1.5] min-h-0" data-id="element-477">
              <AIAssistant data-id="element-478" />
            </div>
          </div>
        </div>
      </main>

      {/* Vehicle Details Drawer */}
      <Drawer isOpen={!!selectedVehicle} onClose={() => setSelectedVehicle(null)} title="Vehicle Profile" data-id="element-479">
        {selectedVehicle && <VehicleDrawer vehicle={selectedVehicle} data-id="element-480" />}
      </Drawer>
    </div>;
}